import { z } from 'zod';

import type { IdAccountDto, IdCompanyDto } from '@/services/ws-invoices/src/main/resources/rest-api';

import type { InvoicesState } from './constants.ts';
import { isInvoicesState } from './helpers/state.ts';
import type { InvoicesFiltersState } from './types.ts';

// An id from a link or the session is a string from outside the app, so the brand is minted behind a check rather than
// asserted: without the predicate z.custom accepts anything at all (js/rules/Api.md, Ids).
export const companyIdSchema = z.custom<IdCompanyDto>((value) => typeof value === 'string');
export const accountIdSchema = z.custom<IdAccountDto>((value) => typeof value === 'string');

/**
 * The query other pages link to the list with. Each key is a filter key of the page, so a link sets the filters it names.
 * `.optional()`, not `.nullable()`: the typed path builder parses every `path()` argument with it, so an absent key must parse.
 */
export const invoicesRouterSearchParamsSchema = z.object({
  search: z.string().optional(),
  invoiceState: z.custom<InvoicesState>(isInvoicesState).optional(),
  agencyId: accountIdSchema.optional(),
  unpaidOnly: z.boolean().optional(),
} satisfies Partial<Record<keyof InvoicesFiltersState, z.ZodTypeAny>>);
